import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => {
  return {
    mainContainer: {
      justifyContent: "stretch",
    },
    aboutMeContainer: {
      width: "100%",
    },
    title: {
      fontWeight: 550,
      fontFamily: "Lato",
      marginRight: "10px",
      fontSize: theme.typography.pxToRem(15),
    },
    videoPlayer: {
      aspectRatio: "16/9",
      width: "100%",
      overflow: "hidden",
    },
    customChipStyle: {
      backgroundColor: "#f3f0f0",
    },
  };
});
